module.exports = {
  A: { api: 'A', human: 'Autohändler' },
  H: { api: 'H', human: 'Halter' },
  W: { api: 'W', human: 'Werkstatt' }
}
